import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiInstance, apiInstanceFetch } from "../../component/api/axiosApi";
import { DangerRight, Success } from "../../component/api/toastServices";

const initialState = {
  setting: {},
  isLoading: false,
  isSkeleton: false,
};

export const getSetting = createAsyncThunk(
  "admin/setting/get",
  async (payload) => {
    return apiInstanceFetch.get("admin/setting/get");
  }
);

export const updateSetting = createAsyncThunk(
  "admin/setting/update",
  async (payload) => {
    return apiInstance.patch(
      `admin/setting/update/${payload.id}`,
      payload.data
    );
  }
);

export const maintenanceMode = createAsyncThunk(
  "admin/setting/appActive",
  async (id) => {
    return apiInstance.put(`admin/setting/appActive?id=${id}`);
  }
);

export const handleSetting = createAsyncThunk(
  "admin/setting/settingSwitch",
  async (payload) => {
    return apiInstance.put(
      `admin/setting/settingSwitch?id=${payload?.id}&type=${payload?.type}`,
      payload.data
    );
  }
);

export const deleteReview = createAsyncThunk(
  "admin/review/delete",
  async (id) => {
    return apiInstance.delete(`admin/review/delete/${id}`);
  }
);

const settingSlice = createSlice({
  name: "settingSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSetting.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(getSetting.fulfilled, (state, action) => {
      state.isLoading = false;
      state.setting = action.payload.setting;
    });

    builder.addCase(getSetting.rejected, (state, action) => {
      state.isLoading = false;
    });

    builder.addCase(updateSetting.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(updateSetting.fulfilled, (state, action) => {
      if (action.payload.status) {
        state.setting = { ...state.setting, ...action.payload.setting };
        Success("Setting Updated Successfully");
      }
      state.isLoading = false;
    });

    builder.addCase(updateSetting.rejected, (state) => {});

    builder.addCase(maintenanceMode.rejected, (state, action) => {
      state.isLoading = false;
      DangerRight('Something went wrong');
    });

    builder.addCase(maintenanceMode.fulfilled, (state, action) => {
      if (action?.payload?.status) {
        state.setting = { ...state.setting, ...action.payload.setting };
        Success("Maintenance Mode Updated Successfully");
      }
      state.isLoading = false;
    });
    
    

    builder.addCase(deleteReview.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(deleteReview.fulfilled, (state, action) => {
      if (action.payload.status) {
        state.setting = state.setting.filter(
          (setting) => setting.id !== action.meta.arg
        );
      }
      state.isLoading = false;
    });

    builder.addCase(deleteReview.rejected, (state, action) => {
      state.isLoading = false;
    });

    builder.addCase(handleSetting.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(handleSetting.fulfilled, (state, action) => {
      state.isLoading = false;
      state.setting = action.payload.setting;
      Success("Updated Successfully");
    });
    builder.addCase(handleSetting.rejected, (state, action) => {
      state.isLoading = false;
    });
  },
});
export default settingSlice.reducer;
